import { MenuItem } from "@szhsin/react-menu";

import cn from "@utils/cn";
// import { useSessionContext } from '@contexts/SessionContext';
import { getIconProps } from "@utils";
import Icon from "@elements/Icon";
import Flags from "@elements/Flags";

const BASE_CLASS_NAMES = cn(`
  group
  flex
  items-center
  justify-start
  gap-x-2
  pl-4
  pr-8
  py-2
  text-base
  font-medium
  tracking-wide
  whitespace-nowrap
  outline-hidden
  cursor-pointer

  bg-menu-item-bg
  text-menu-item-text
  [--icon-background-color:var(--color-menu-item-bg)]
  [--icon-transition-duration:0s]

  hover:bg-menu-item-bg-hover
  hover:text-menu-item-text-hover
  hover:[--icon-background-color:var(--color-menu-item-bg-hover)]

  focus:bg-menu-item-bg-focus
  focus:text-menu-item-text-hover
  focus:[--icon-background-color:var(--color-menu-item-bg-focus)]

  active:bg-menu-item-bg-active
  active:text-menu-item-text-active
  active:[--icon-background-color:var(--color-menu-item-bg-active)]

  data-[selected=true]:bg-(--navbar-menu-active-background-color)
  data-[selected=true]:text-white
  data-[selected=true]:[--icon-background-color:var(--navbar-menu-active-background-color)]
`);

const DISABLED_CLASS_NAMES = cn(`
  cursor-not-allowed

  bg-menu-item-disabled-bg
  text-menu-item-disabled-text
  [--icon-background-color:var(--color-menu-item-disabled-bg)]

  hover:bg-menu-item-disabled-bg
  hover:text-menu-item-disabled-text

  focus:bg-menu-item-disabled-bg
  focus:text-menu-item-disabled-text

  active:bg-menu-item-disabled-bg
  active:text-menu-item-disabled-text
`);

export default function NavbarMenuBaseItem(props) {
  const {
    className,
    label = {},
    onClick,
    tooltip,

    isDisabled,
    isSelected,
    isAdminOnly,
    flags = [],
  } = props;

  const {
    text,
    icon,
  } = label;

  const iconProps = getIconProps(icon, {
    fixedWidth: true,
  });

  // const { isCurrentPage } = useSessionContext();
  // const isActive = isCurrentPage(pageKey);

  const classNames = cn(BASE_CLASS_NAMES, className, {
    [DISABLED_CLASS_NAMES]: isDisabled,
  });

  /**************************************************************************************************/

  return (
    <MenuItem
      className={classNames}
      onClick={onClick}
      disabled={isDisabled}
      data-selected={isSelected}
    >
      {iconProps && (
        <span className="my-0 text-sm align-middle transition-all duration-250 ease-in-out">
          <Icon {...iconProps} />
        </span>
      )}

      <span
        data-tooltip-id={tooltip ? "app-tooltip" : undefined}
        data-tooltip-content={tooltip}
      >
        {text}
        {isAdminOnly ? "*" : ""}
      </span>

      <Flags
        flags={flags}
        flagClassNames="opacity-75"
        displayTooltip={false}
      />
    </MenuItem>
  );
};
